import React from 'react'
import classnames from 'classnames'
import { TextFieldDisplayType } from '@deal/components'
import { ListPathFlowQuestionDefinition } from '#src/components/Path/Question'
import DropDown from '../../../../components/ListPathFlowQuestion/DropDown'
import MultiSelect from './MultiSelect'
import SelectList from './SelectList'
import { FormContextConsumer, FormContextType } from '#src/components/Path/FormContext'
import { ListPathFlowQuestionType } from '#src/generated/graphql'
import styles from './styles.css'

export interface ListPathFlowQuestionProps extends ListPathFlowQuestionDefinition<CustomProps> {
  value: string | null
  animationDelay: number
  style: { [key: string]: string | number }
}

interface CustomProps {
  className?: string
  hideIcon?: boolean
  display?: TextFieldDisplayType
}

class ListPathFlowQuestion extends React.PureComponent<
  ListPathFlowQuestionDefinition<CustomProps> & { context: FormContextType }
> {
  public componentDidMount() {
    const { question } = this.props
    const questionValues = question.listUserInput.value

    if (!question.required) {
      this.props.onFieldValidityChanged(true)
    }

    if (questionValues && questionValues.length > 0) {
      this.props.onFieldValueChanged({ value: questionValues })
      this.props.onFieldValidityChanged(true)
    }
  }

  public deriveComponentType(type: ListPathFlowQuestionType) {
    switch (type) {
      case ListPathFlowQuestionType.MULTI_SELECT_LIST:
      case ListPathFlowQuestionType.SINGLE_SELECT_LIST:
        return SelectList

      case ListPathFlowQuestionType.MULTI_SELECT_PILLS:
        return MultiSelect

      case ListPathFlowQuestionType.DROP_DOWN:
        return DropDown
    }

    throw new Error(`Unhandled ListPathFlowQuestion type [${type}]`)
  }

  public render() {
    const { question, contentfulSettings, ...rest } = this.props
    const SelectComponent = this.deriveComponentType(question.listType)
    const hasSettings = !!(contentfulSettings && contentfulSettings.content)

    return (
      <SelectComponent
        question={question}
        value={question.listUserInput.value ? question.listUserInput.value.join(',') : null}
        className={classnames(styles.animatedLabel, {
          [styles.animatedWithOpacity]:
            hasSettings && contentfulSettings!.content!.hasFadeIn !== undefined
              ? contentfulSettings!.content!.hasFadeIn
              : true,
          [styles.animatedWithMovement]:
            hasSettings && contentfulSettings!.content!.hasMovement !== undefined
              ? contentfulSettings!.content!.hasMovement
              : true,
          [styles.animatedOnlyMovement]: !!(
            hasSettings &&
            contentfulSettings!.content!.hasMovement &&
            contentfulSettings!.content!.hasFadeIn === false
          )
        })}
        animationDelay={(hasSettings && contentfulSettings!.content!.animationDelay) || 0.2}
        style={{
          animationDuration: `${(hasSettings && contentfulSettings!.content!.animationDuration) ||
            1}s`
        }}
        {...rest}
      />
    )
  }
}

const ListPathFlowQuestionWithContext: React.SFC<ListPathFlowQuestionDefinition<CustomProps>> = ({
  ...rest
}) => (
  <FormContextConsumer>
    {formData => (formData ? <ListPathFlowQuestion context={formData} {...rest} /> : null)}
  </FormContextConsumer>
)

export default ListPathFlowQuestionWithContext
